import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=04057e36&"
import script from "./servers.vue?vue&type=script&lang=ts&"
export * from "./servers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports